import {createContext} from 'react';

export const RouteContext = createContext({});

export const {Consumer: RouteConsumer, Provider: RouteProvider} = RouteContext;

export default RouteContext;
